import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { useAuth } from "../../components/context/authContext";
import OfferForm from "../../components/forms/offerForm";
import { MemberSlider } from "../../components/buttons";
import AmbassadorLeaderBoard from "../../components/ambassadorLeaderBoard/ambassadorLeaderBoard";
import ChangeRole from "../../components/changeRole/changeRole";
import {
  GlassBtn,
  ImgTopBtn,
  SmallPlainInsetBtn,
} from "../../components/buttons";
import {
  MoneyBagIcon,
  EyeIcon,
  EyeSlashIcon,
  EarnedIcon,
  LineIntersectingCircleIcon,
  EventCalendarIcon,
  WhistleIcon,
  BankIcon,
  TournamentControlPanelIcon,
} from "../../components/icons";
import {
  apiGetAtRiskAmbassadors,
  apiGetAmbassadors,
  apiGetBrandAmbassadorsTopPerformers,
  apiFetchWhistleSkitBlownData,
  apiFetchSuspendedCommunications,
} from "../../api/backend/admin";
import Loader from "../../components/loader/loader";
import "./adminDashboard.scss";
// live or delete the comment, the children would also have to be deleted. put the username
// On top of the username slider show reporting metrics with count.
// Too many means remove the member. Look at community standards.
// need a button where I can make the user not live..this will suspend the user so they can
// not signup again.

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { currentMemberId, handleLogout } = useAuth();
  const [whistleBlownSkitCount, setWhistleBlownSkitCount] = useState(0);
  const [whistleBlownCommentCount, setWhistleBlownCommentCount] = useState(0);
  // State to toggle the OfferForm and the Ambassador list
  const [atRiskAmbassadors, setAtRiskAmbassadors] = useState([]);
  const [loadingAtRisk, setLoadingAtRisk] = useState(false);
  const [errorAtRisk, setErrorAtRisk] = useState(null);
  const [showAmbassadors, setShowAmbassadors] = useState(false);
  const [error, setError] = useState(null);
  const [brandAmbassadors, setBrandAmbassadors] = useState([]);
  const [showOfferForm, setShowOfferForm] = useState(false);

  const [topPerformers, setTopPerformers] = useState([]);
  const [loadingTop, setLoadingTop] = useState(false);
  const [errorTop, setErrorTop] = useState(null);
  const [loading, setLoading] = useState(false);
  // 1) fetcher:
  const fetchAtRiskAmbassadors = async () => {
    setLoadingAtRisk(true);
    try {
      const res = await apiGetAtRiskAmbassadors();
      // res.data === { ambassadors: [...] } below or pulling out the inner array to get all ambassadors
      setAtRiskAmbassadors(res.data.ambassadors);
      setErrorAtRisk(null);
    } catch (err) {
      console.error(err);
      setErrorAtRisk(err);
    } finally {
      setLoadingAtRisk(false);
    }
  };
  // 2) on mount:
  useEffect(() => {
    fetchAtRiskAmbassadors();
  }, []);

  // 1) load skit + comment badge counts
  useEffect(() => {
    async function loadNotificationBadges() {
      try {
        const [skitRes, commRes] = await Promise.all([
          apiFetchWhistleSkitBlownData({
            limit: 0,
            offsetNeedsReview: 0,
            offsetSuspended: 0,
          }),
          apiFetchSuspendedCommunications({ limit: 0, offset: 0 }),
        ]);

        setWhistleBlownSkitCount(skitRes.data.data.needsReview.length);
        setWhistleBlownCommentCount(commRes.data.data.suspended.length);
      } catch (err) {
        console.error("Error loading badge counts", err);
      }
    }
    loadNotificationBadges();
  }, []);

  // const fetchTopPerformers = async () => {
  //   setLoadingTop(true);
  //   setErrorTop(null);
  //   try {
  //     const res = await apiGetBrandAmbassadorsTopPerformers(10); // or any N
  //     setTopPerformers(res.data.performers || []);
  //   } catch (err) {
  //     console.error(err);
  //     setErrorTop("Could not load top performers.");
  //   } finally {
  //     setLoadingTop(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchTopPerformers();
  // }, []);

  const fetchBrandAmbassadorHandler = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiGetAmbassadors();
      // your endpoint returns { ambassadors: [...] }
      setBrandAmbassadors(res.data.ambassadors || []);
    } catch (err) {
      console.error("Error fetching ambassadors:", err);
      setError("Could not load ambassadors");
    } finally {
      setLoading(false);
    }
  };

  const toggleAndFetch = () => {
    // if we're about to open the panel, fetch first
    if (!showAmbassadors) fetchBrandAmbassadorHandler();
    setShowAmbassadors((s) => !s);
  };

  // Callback from OfferForm when the offer submission starts.
  const handleOfferScheduleAttempted = () => {
    setLoading(true);
  };

  // Callback from OfferForm when an offer is successfully created.
  const handleOfferSchedule = (offer) => {
    console.log("Offer created successfully:", offer);
    setLoading(false);
    setShowOfferForm(false);
  };

  const scrollWithOffset = (el, offset) => {
    const elementPosition = el.getBoundingClientRect().top;
    const scrollY = window.scrollY;
    const offsetPosition = elementPosition + scrollY - offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };
  // Function to open the ambassador dashboard in a new window

  const openAmbassadorDashboard = (ambassador) => {
    // Navigate to the ambassador dashboard route
    navigate(`/user-profile/${ambassador.id}/ambassador-dashboard`);
  };
  const onLogoutClick = () => {
    handleLogout();
    navigate("/");
  };

  return (
    <div className="admin-dashboard">
      <p>Admin Dashboard Panel</p>
      <div className="admin-top-buttons">
        <ImgTopBtn
          image={<LineIntersectingCircleIcon width="25" height="25" />}
          imgTopBtnWidth="50%"
          imgTopBtnTextFontSize="1.3rem"
          imgTopBtnFontColor="#b03a2e"
          imgTopBtnText="Logout"
          onClick={() => {
            onLogoutClick();
          }}
        />
        <HashLink
          to={`/members-status-page/${currentMemberId}#topMemberStatusPage`}
          scroll={(el) => scrollWithOffset(el, 50)}
          style={{ textDecoration: "none" }}
        >
          <ImgTopBtn
            image={<LineIntersectingCircleIcon width="25" height="25" />}
            imgTopBtnTextFontSize="1.3rem"
            imgTopBtnFontColor="#b03a2e"
            imgTopBtnText="Change Member Status"
          />
        </HashLink>
      </div>
      <HashLink
        to={`/user-profile/${currentMemberId}/tournament-control-panel#topTournamentControlPanel`}
        scroll={(el) => scrollWithOffset(el, 50)}
        style={{ textDecoration: "none" }}
      >
        <ImgTopBtn
          image={
            <TournamentControlPanelIcon
              width="20"
              height="20"
              strokeColor="var(--color-bloodred)"
            />
          }
          imgTopBtnWidth="fit-content"
          imgTopBtnTextFontSize="1.3rem"
          imgTopBtnFontColor="var(--color-bloodred)"
          imgTopBtnText="Tournament Control Panel"
        />
      </HashLink>
      <div className="admin-report-page-redirect-btns">
        <HashLink
          to={`/admin-dashboard/${currentMemberId}/whistle-blown-skit-page#topWhistleBlownSkitPage`}
          scroll={(el) => scrollWithOffset(el, 50)}
          style={{
            textDecoration: "none",
          }}
        >
          <div className="btn-with-badge">
            <SmallPlainInsetBtn
              image={
                <WhistleIcon
                  height="20px"
                  width="20px"
                  fillColor="var(--color-bloodred)"
                  style={{ marginRight: 4 }}
                />
              }
              text="Skit Reports"
              width="200px"
              style={{
                fontSize: "1rem",
              }}
            />
            {whistleBlownSkitCount > 0 && (
              <span className="btn-badge">{whistleBlownSkitCount}</span>
            )}
          </div>
        </HashLink>
        <HashLink
          to={`/admin-dashboard/${currentMemberId}/whistle-blown-comment-page#topWhistleBlownCommentPage`}
          scroll={(el) => scrollWithOffset(el, 50)}
          style={{
            textDecoration: "none",
          }}
        >
          <div className="btn-with-badge">
            <SmallPlainInsetBtn
              image={
                <WhistleIcon
                  height="20px"
                  width="20px"
                  fillColor="var(--color-bloodred)"
                  style={{ marginRight: 4 }}
                />
              }
              text="Comment Reports"
              width="200px"
              style={{
                fontSize: "1rem",
              }}
            />
            {whistleBlownCommentCount > 0 && (
              <span className="btn-badge">{whistleBlownCommentCount}</span>
            )}
          </div>
        </HashLink>
      </div>
      <div className="accounts-payable-admin-buttons">
        <HashLink
          to={`/accounts-payable-dashboard/${currentMemberId}/wages-payable#contractorsAccountingTop`}
          scroll={(el) => scrollWithOffset(el, 50)}
          style={{ textDecoration: "none", flex: "1 1 120px" }}
        >
          <ImgTopBtn
            className=""
            image={
              <BankIcon
                height="20px"
                width="20px"
                style={{ paddingRight: "5px" }}
              />
            }
            imgTopBtnText="Wages Payable"
            imgTopBtnWidth="100%"
            imgTopBtnFontColor="var(--color-bloodred)"
            position="relative"
          />
        </HashLink>
        <HashLink
          to={`/accounts-payable-dashboard/${currentMemberId}/accounts-payable#accountsPayableTop`}
          scroll={(el) => scrollWithOffset(el, 50)}
          style={{ textDecoration: "none", flex: "1 1 120px" }}
        >
          <ImgTopBtn
            className="responsive-btn"
            image={
              <EarnedIcon
                height="20px"
                width="20px"
                style={{ paddingRight: "5px" }}
              />
            }
            imgTopBtnText="Accounts Payable Transaction History"
            imgTopBtnWidth="100%"
            imgTopBtnFontColor="var(--color-bloodred)"
            position="relative"
          />
        </HashLink>
      </div>
      <ChangeRole onSuccess={fetchAtRiskAmbassadors} />
      <ImgTopBtn
        image={
          <MoneyBagIcon
            width="25"
            height="25"
            style={{
              marginRight: "5px",
            }}
          />
        }
        imgTopBtnWidth="50%"
        imgTopBtnTextFontSize="1.3rem"
        imgTopBtnFontColor="var(--color-bloodred)"
        imgTopBtnText="Create Offer"
        onClick={() => setShowOfferForm(true)}
      />
      {/* Offers Section */}
      {showOfferForm && (
        <>
          <div className="glass-overlay" />
          <div className="offer-form-wrapper">
            <OfferForm
              onAttemptedSubmitOfferSchedule={handleOfferScheduleAttempted}
              onScheduleOfferCreated={handleOfferSchedule}
              onCancel={() => setShowOfferForm(false)}
            />
          </div>
        </>
      )}
      <GlassBtn
        glassBtnImage={
          showAmbassadors ? (
            <EyeSlashIcon
              height="25px"
              width="25px"
              fillColor="var(--color-gold)"
            />
          ) : (
            <EyeIcon height="25px" width="25px" fillColor="var(--color-gold)" />
          )
        }
        glassHoverStyle={{
          height: "60px",
        }}
        onClick={toggleAndFetch}
        className="updateCtrl"
        glassBtnText={showAmbassadors ? "Hide Team" : "View Team"}
        glassBtnTextFontSize="1.3rem"
        glassBtnFontWeight="900"
        glassBtnFontColor="var(--color-gold)"
        glassBtnTextDecorationColor="var(--color-gold)"
      />
      {/* Loading indicator */}
      {loading && (
        <div>
          <Loader />
        </div>
      )}
      {showAmbassadors && (
        <div className="ambassadors-list">
          <h3>Brand Ambassadors</h3>
          <ul>
            {brandAmbassadors.map((amb) => (
              <li key={amb.id}>
                <MemberSlider
                  user={amb}
                  slideBtnText="View Dashboard"
                  onHandleSlideEnd={() => openAmbassadorDashboard(amb)}
                />
                <div className="user-details">
                  <span className="username">{amb.name}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
      <section className="at-risk-section">
        <h3>Ambassadors At Risk</h3>
        {loadingAtRisk && <p>Loading…</p>}
        {errorAtRisk && <p>Error loading at-risk list.</p>}
        {!loadingAtRisk && !errorAtRisk && (
          <ul>
            {atRiskAmbassadors.length ? (
              atRiskAmbassadors.map((amb) => (
                <li key={amb.id}>
                  {amb.name} (ID: {amb.id})
                </li>
              ))
            ) : (
              <li>None currently at risk 🎉</li>
            )}
          </ul>
        )}
      </section>
      {/* Team Schedule Section */}
      <HashLink
        to={`/staff/${currentMemberId}/schedule#scheduleTop`}
        scroll={(el) => scrollWithOffset(el, 50)}
        style={{
          textDecoration: "none",
        }}
      >
        <SmallPlainInsetBtn
          image={
            <EventCalendarIcon
              height="20px"
              width="20px"
              fillColor="var(--color-bloodred)"
              style={{ marginRight: "3px" }}
            />
          }
          text="Schedule"
          width="100px"
          style={{
            fontSize: "1rem",
          }}
        />
      </HashLink>
      {/* Leaderboard Section */}
      {/* <h2>Ambassadors Team Leader Board</h2>
      <AmbassadorLeaderBoard performers={topPerformers} /> */}
    </div>
  );
};

export default AdminDashboard;
